module.exports = __webpack_public_path__ + "img/main-logo.b6406739.png";